import React, {useEffect, useRef} from 'react';
import {Drawer, Tabs} from '@mantine/core';
import {IconDialpad, IconSearch} from '@tabler/icons-react';
import {useTranslation} from 'react-i18next';
import {AccountService} from '@bobex/react-core/services/AccountService';
import {
    AdministratorModelConstants
} from '@bobex/react-core/domain/AdministratorModel/constants/AdministratorModelConstants';
import CpvTab from './CpvTab';
import SearchHeaderTabContent from '@/components/SearchHeader/SearchHeaderTabContent';

export type RightPanelTab = 'search' | 'cpv';

interface SearchHeaderProps {
  isVisible: boolean;
  onClose: () => void;
  /** Which tab to show when opening (e.g. 'cpv' when opening from dialpad). */
  activeTab?: RightPanelTab;
}

export default function RightDrawer({
  isVisible,
  onClose,
  activeTab = 'search',
}: SearchHeaderProps) {
  const [tab, setTab] = React.useState<RightPanelTab>(activeTab);

  useEffect(() => {
    if (isVisible) setTab(activeTab);
  }, [isVisible, activeTab]);
  const { t } = useTranslation();

  const companyInputRef = useRef<HTMLInputElement>(null);
  const phoneInputRef = useRef<HTMLInputElement>(null);



  // Focus company input if a user has a specific user group
  useEffect(() => {
    if (isVisible) {
      const currentUser = AccountService.getUser();
      // You can modify this condition based on which user groups should trigger focus,
      // For example, focusing for PARTNER_EXPERT users
      if (currentUser && currentUser.departmentId != AdministratorModelConstants.ADMIN_DEPARTMENT_VALID) {
        // Small delay to ensure the drawer is fully rendered
        setTimeout(() => {
          companyInputRef.current?.focus();
        }, 100);
      } else {
        // If the user is not in the specific group, focus on leadIdInputRef
        setTimeout(() => {
          phoneInputRef.current?.focus();
        }, 100);
      }
    }
  }, [isVisible]);




  return (
    <Drawer
      opened={isVisible}
      onClose={onClose}
      title={null}
      position="right"
      size="md"
      padding="md"
      withCloseButton
    >
      <Tabs value={tab} onChange={(v) => setTab((v as RightPanelTab) || 'search')}>
        <Tabs.List>
          <Tabs.Tab value="search" leftSection={<IconSearch size={16} />}>
            {t('sidebar.tabs.search')}
          </Tabs.Tab>
          <Tabs.Tab value="cpv" leftSection={<IconDialpad size={16} />}>
            {t('sidebar.tabs.cpvCodes')}
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="search" pt="md">
          <SearchHeaderTabContent onClose={onClose} />
        </Tabs.Panel>

        <Tabs.Panel value="cpv" pt="md" px="md">
          <CpvTab isVisible={isVisible && tab === 'cpv'} />
        </Tabs.Panel>
      </Tabs>
    </Drawer>
  );
}
